import { enUS } from 'date-fns/locale/en-US'
import z from 'zod'

import type { Locale } from 'date-fns'

export const SUPPORTED_LOCALES_ENUM = z.enum(['en-US'])
export type SupportedLocales = z.infer<typeof SUPPORTED_LOCALES_ENUM>

/**
 * Map of supported locales
 *
 * Using Map instead of Record for faster lookup
 */
export const localeMap: Map<SupportedLocales, Locale> = new Map([
	['en-US', enUS],
])
